<!-- Hero Section -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="healthcare-heading mb-3">
                        Hi-Tech Software Development for Future-Ready Enterprises
                    </h1>
                    <!-- <p class="healthcare-subheading1 mb-4">
            Health Care Industries
          </p> -->
                    <p class="healthcare-subheading2 mb-4">
                        In the hi-tech industry, speed defines survival. While competitors leverage AI to ship products
                        3x faster, legacy systems and fragmented workflows hold many enterprises back. Transform your
                        hi-tech ecosystem with AI-driven, cloud-native, and enterprise-grade software solutions that
                        don't just accelerate innovation—they redefine what's possible
                    </p>
                    <!-- <p class="healthcare-subheading3 mb-4">
            We optimize your healthcare workflows through our custom-built software solutions.
          </p> -->
                    <div class="mb-5 contact-btn">
                        <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
                        <button class="btn hire-btn hire" (click)="scheduleDemo()">
                            Book a Free Consultation
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/industries/hitech/hitech-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mx-auto">
            <h2>Why the Hi-Tech Industry Needs Smarter Software Solutions </h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="solutions-image-container">
                    <div class="solution-image-card image-one">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/hitech/hitech-img1.png"
                            alt="Team collaborating on computer">
                    </div>
                    <div class="solution-image-card image-two">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/hitech/hitech-img2.png"
                            alt="Two colleagues looking at a laptop">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="solutions-content">
                    <!-- <p>
                        The financial services landscape is rapidly evolving, from rising compliance demands to growing
                        expectations for faster, secure, and seamless digital payments. Traditional processes often
                        limit speed, accuracy, and customer satisfaction. At Kalpita Technologies, we empower finance
                        companies with custom fintech app development, AI-powered fintech solutions, blockchain
                        integration, and intelligent automation, that modernize operations, strengthen transaction
                        security, and scale revenue-driven innovation.
                    </p> -->
                    <p>The hi-tech sector faces unprecedented challenges:</p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg"
                                    alt="Indicator"><strong>Time-to-Market
                                    Pressure: </strong>Product cycles shortened from 18 months to 6 months</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator"><strong>Technical
                                    Debt: </strong>60%
                                of engineering time spent maintaining legacy systems</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator"><strong>Data Silos:
                                </strong>Critical
                                insights trapped across 10+ disconnected platforms</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator"><strong>Scalability
                                    Gaps: </strong>
                                Infrastructure that can't support 10x growth projections</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator"><strong>AI
                                    Integration
                                    Complexity: </strong>Difficulty embedding intelligent automation into existing
                                workflows</li>
                        </ul>
                    </div>
                    <p>Our solutions are designed to help organizations stay competitive, scalable, and innovative and
                        realize these key benefits:</p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Faster innovation
                                with AI-powered automation</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Improved scalability
                                through cloud-native architecture</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Reduced operational
                                costs and system inefficiencies</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Real-time insights
                                with smart analytics and ML models</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Enhanced user
                                experience with modern digital platforms</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
    <div class="container">
        <div class="text-center">
            <h2 class="impact-heading">Kalpita Technologies’ Hi-Tech Software Solutions</h2>
        </div>
        <div class="row align-items-center impact-main-content">
            <!-- Added Animation Trigger -->
            <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    At Kalpita Technologies, we provide hi-tech enterprises with end-to-end software development
                    services to build modern, agile, and future-ready digital ecosystems. Our expertise ensures seamless
                    integration, robust performance, and delivers measurable business outcomes by leveraging our hi-tech
                    solution accelerators and frameworks such as:
                </p>
                <!-- Added animate-item class -->
                <ul class="simple-impact-list animate-item">
                    <li>
                        <strong>AI-Powered Development Pipelines:</strong> Reduce coding time by 40% with intelligent
                        code generation and automated testing
                    </li>
                    <li>
                        <strong>Cloud-Native Architectures:</strong> Kubernetes-based microservices for unlimited
                        scalability
                    </li>
                    <li>
                        <strong>Legacy Modernization:</strong> Phased migration strategies with zero downtime
                    </li>
                    <li>
                        <strong>Intelligent Automation Platforms:</strong> Custom RPA solutions integrated with ML
                        decision engines
                    </li>
                    <li>
                        <strong>Real-Time Data Platforms:</strong> Event-driven architectures for instant insights
                    </li>
                </ul>
            </div>
            <div class="col-lg-6">
                <!-- Added Shine Effect -->
                <div class="impact-image-wrapper">
                    <img src="../../../../assets/industries/hitech/hitechsolutions-img.jpg"
                        alt="Developer working on multiple screens">
                    <div class="shine"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
    <div class="container">

        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Real-World Success Stories in Hi-Tech</h2>
                <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
            </div>
        </div>

        <!-- Slider Wrapper -->
        <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

            <!-- The Sliding Track -->
            <div class="slider-viewport">
                <div class="slider-track" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'"
                    [class.single-slide]="caseStudies.length === 1">

                    <!-- Loop through Case Studies -->
                    <div class="case-study-slide" *ngFor="let study of caseStudies">
                        <div class="row align-items-center">

                            <!-- Image Column (Left) -->
                            <div class="col-lg-5 d-flex justify-content-center">
                                <div class="case-study-image-wrapper">
                                    <img [src]="study.image" [alt]="study.title" class="img-fluid">
                                </div>
                            </div>

                            <!-- Content Column (Right) -->
                            <div class="col-lg-7">
                                <div class="case-study-content">
                                    <h3 class="case-study-title">{{ study.title }}</h3>
                                    <p class="case-study-description">
                                        {{ study.description }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- End Loop -->

                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-dots" *ngIf="caseStudies.length > 1">
                <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
                </span>
            </div>

        </div>
    </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h2 class="healthcare-heading mb-3">
                        Client Testimonials
                    </h2>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="testimonials()">
                            Explore what our clients say
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
                        class="img-fluid testimonial-hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="HiTechFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Build Your Next-Gen Hi-Tech Solution with Us</h2>

                <div class="mb-5 cta-btn-group">
                    <!-- <button class="btn btn-get-started me-3" (click)="getStarted()">
            Get Started
          </button> -->
                    <button class="btn btn-schedule-demo" (click)="scheduleDemo()">
                        Schedule a Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>